import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Load environment variables
declare global {
  interface Window {
    embeddedChatbotConfig?: {
      chatbotId: string;
      domain: string;
    };
  }
}

const Chatbase = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/checkout")) {
      // Remove elements with id starting with "chatbase-bubble"
      document
        .querySelectorAll('[id^="chatbase-bubble"]')
        .forEach((element) => {
          (element as HTMLElement).style.visibility = "hidden";
        });

      // Remove elements with id starting with "chatbase-message"
      document
        .querySelectorAll('[id^="chatbase-message"]')
        .forEach((element) => {
          (element as HTMLElement).style.visibility = "hidden";
        });
    } else {
      if (!window.embeddedChatbotConfig) {
        const script = document.createElement("script");
        window.embeddedChatbotConfig = {
          chatbotId: "jynEGF-WlQt6AyQzxlsZJ",
          domain: "www.chatbase.co"
        };

        Object.assign(script, {
          type: "text/javascript",
          domain: "www.chatbase.co",
          chatbotId: "jynEGF-WlQt6AyQzxlsZJ",
          src: "https://www.chatbase.co/embed.min.js"
        });

        document.head.appendChild(script);
      }
      // Make elements with id starting with "chatbase-bubble" visible
      document
        .querySelectorAll('[id^="chatbase-bubble"]')
        .forEach((element) => {
          (element as HTMLElement).style.visibility = "visible";
        });

      // Making elements with id starting with "chatbase-message" visible
      document
        .querySelectorAll('[id^="chatbase-message"]')
        .forEach((element) => {
          (element as HTMLElement).style.visibility = "visible";
        });
    }
  }, [pathname]);

  return null;
};

export default Chatbase;
